import * as importedSdk from 'sharetribe-flex-sdk';

let exportSdk;

const isServer = () => typeof window === 'undefined';

if (isServer()) {
  // Use eval to skip webpack from bundling SDK in Node
  // eslint-disable-next-line no-eval
  exportSdk = eval('require')('sharetribe-flex-sdk');
} else {
  exportSdk = importedSdk;
}

const { createInstance, types, transit, util } = exportSdk;

// create image variant from variant name, desired width and aspectRatio
// When fit is 'scale', we only specify width to preserve original aspect ratio
const createImageVariantConfig = (name, width, aspectRatio) => {
  let variantWidth = width;

  if (variantWidth > 3072) {
    console.error(`Width of custom image variant (${name}) is too high (w:${variantWidth}).
    Reduce it to max 3072px. https://www.sharetribe.com/api-reference/marketplace.html#custom-image-variants`);
    variantWidth = 3072;
  }

  // Use 'scale' fit with only width specified to preserve original aspect ratio
  // This prevents cropping and shows the full image
  return {
    [`imageVariant.${name}`]: util.objectQueryString({
      w: variantWidth,
      fit: 'scale',
    }),
  };
};


export { createInstance, types, transit, util, createImageVariantConfig };
